import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
import {
  firebaseConfig,
  firebaseDbUrl
} from '@/config'

const app = firebase.initializeApp(firebaseConfig)

export default app
export const firebaseDb = app.database()
export const firebaseTestDb = app.database(firebaseDbUrl.test)
export const firebaseBankDb = app.database(firebaseDbUrl.quizBank)
export const firebaseAuth = firebase.auth
export const DB_TIMESTAMP = firebase.database.ServerValue.TIMESTAMP
